import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  KlaviyoIntegrationResponseDataSchema,
  UpsertKlaviyoIntegration,
} from "schema"
import { z } from "zod"
import { klaviyoIntegrationQuery } from "../../lib/klaviyo/klaviyoIntegrationQuery"

type Response = DataResponse<z.infer<typeof KlaviyoIntegrationResponseDataSchema>>

export function useCreateKlaviyoIntegrationConfigurationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertKlaviyoIntegration>) => {
      const response = await axios.post<Response>(`/integrations/klaviyo`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: klaviyoIntegrationQuery().queryKey })
    },
  })
}
